import type { SVGProps } from 'react';
const checkboxEmptyUnchecked = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={25} viewBox="0 0 24 25" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M3 5.75C3 4.50736 4.00736 3.5 5.25 3.5H18.75C19.9926 3.5 21 4.50736 21 5.75V19.25C21 20.4926 19.9926 21.5 18.75 21.5H5.25C4.00736 21.5 3 20.4926 3 19.25V5.75ZM5.25 5C4.83579 5 4.5 5.33579 4.5 5.75V19.25C4.5 19.6642 4.83579 20 5.25 20H18.75C19.1642 20 19.5 19.6642 19.5 19.25V5.75C19.5 5.33579 19.1642 5 18.75 5H5.25Z"
      fill={props.color ?? 'black'}
      fillRule="evenodd"
    />
  </svg>
);
export default checkboxEmptyUnchecked;
